import { undefOrNull } from './objects';

export const stringArraySomeIncludes = (array: Array<string>, string: string): boolean => {
  return array.some((el: string) => string.includes(el));
};

export const removeUndef = <T = any | undefined>(data: T[]): T[] => {
  return data.filter(element => !undefOrNull(element));
};

export const toStringSeparateByComma = (array: string[]): string => {
  return array.reduce((p, c) => `${p}, ${c}`);
};
